import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import API from '../../../../api-graphql';
import { withStyles } from '@material-ui/core/styles';
import { Card, CardActions, CardContent, Typography, IconButton, Link, Tooltip, Menu, MenuItem, ListItemIcon, ListItemText } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import EditIcon from '@material-ui/icons/EditOutlined';
import MoreIcon from '@material-ui/icons/MoreHorizOutlined';
import AddDocIcon from '@material-ui/icons/NoteAddOutlined';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import InsertDriveFile from '@material-ui/icons/InsertDriveFile';
import { AlertDialog } from '../../../UI/AlertDialog';
import LoadingCard from '../../../UI/LoadingCard';
import { styles } from './styles';
import { withTranslation } from 'react-i18next';

function TemplateCard (props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [deleteTemplateDialog, setDeleteTemplateDialog] = useState(false);
  const { classes, t, template, getTemplates } = props;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDeleteTemplate = async (choise) => {
    setDeleteTemplateDialog(false);
    if (choise) {
      setMessage(t('documentMenu:delete'));
      setLoading(true);
      API.updateTemplate({ id: template.id, status: 'DELETED' })
        .then(async () => {
          setMessage(t('documentMenu:ready'));
          await getTemplates();
          setTimeout(() => {
            setLoading(false);
          }, 2000);
        }).catch((err) => {
          console.error(err);
          setMessage(t('documentMenu:error'));
          setTimeout(() => setLoading(false), 2000);
        });
    }
  };
  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContent}>
        <div style={{ textAlign: 'center' }}>
          <InsertDriveFile style={{ marginTop: '24px', fontSize: '3rem', opacity: 0.5 }} color='primary' />
          <Typography variant='h5' align='left' style={{ marginTop: '45px', marginLeft: '16px' }}>
            {template.name}
          </Typography>
          <Typography variant='body1' gutterBottom align='left' style={{ color: 'rgba(0,0,0,0.38)', marginTop: '10px', marginLeft: '16px' }}>
            {template.description}
          </Typography>
        </div>
      </CardContent>
      {template.status !== 'DELETED' && (
        <CardActions className={classes.cardActions}>
          <Link component={RouterLink} to={`/template/${template.id}`}>
            <Tooltip disableFocusListener title={t('templateCard:newDocument')}>
              <IconButton><AddDocIcon style={{ fontSize: '1.5rem', color: 'rgba(0,0,0,0.54)' }} /></IconButton>
            </Tooltip>
          </Link>
          <Link component={RouterLink} to={`/template/view/${template.id}`}>
            <Tooltip disableFocusListener title={t('templateCard:watchTemplate')}>
              <IconButton><VisibilityOutlinedIcon style={{ fontSize: '1.5rem', color: 'rgba(0,0,0,0.54)' }} /></IconButton>
            </Tooltip>
          </Link>
          <Link>
            <Tooltip disableFocusListener title={t('templateCard:moreActions')}>
              <IconButton
                aria-owns={anchorEl ? 'card-menu' : undefined}
                aria-haspopup='true'
                onClick={handleClick}>
                <MoreIcon style={{ fontSize: '1.5rem', color: 'rgba(0,0,0,0.54)' }} />
              </IconButton>
            </Tooltip>
            <Menu id='card-menu' anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose} >
              <MenuItem>
                <RouterLink to={`/template/edit/${template.id}`} style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                  <ListItemIcon className={classes.icon}><EditIcon /></ListItemIcon>
                  <ListItemText primary={t('templateCard:edit')} />
                </RouterLink>
              </MenuItem>
              <MenuItem onClick={() => setDeleteTemplateDialog(true)}>
                <ListItemIcon className={classes.icon}><DeleteIcon /></ListItemIcon>
                <ListItemText classes={{ primary: classes.primary }} primary={t('templateCard:remove')} />
              </MenuItem>
            </Menu>
          </Link>
        </CardActions>
      )}
      {deleteTemplateDialog &&
      <AlertDialog
        description={t('documentMenu:deleteConfirmationMessage')}
        callbackFunc={handleDeleteTemplate}
        open={deleteTemplateDialog}
        setOpen={setDeleteTemplateDialog}
      />}
      <LoadingCard open={loading} loading={loading} message={message} />
    </Card>
  );
}

TemplateCard.propTypes = {
  classes: PropTypes.object.isRequired,
  template: PropTypes.object.isRequired,
  getTemplates: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

export default withTranslation()(withStyles(styles, { withTheme: true })(TemplateCard));
